import FlashLib from "flashlib";
import {TweenMax} from "gsap/TweenMax";
import EntryPoint from "../../EntryPoint";

export default class BaseSlotSymbol extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.id = 1;
        this.animationTween = null;
        this.config = EntryPoint.configData.symbols;
        this.incativeTintColor = 0x676767; //0x666666
        this.active = true;

        this.init();
        this.createTweens();
        this.changeSymbol(this.id);
    }

    init() {

    }

    createTweens() {
        this.animationTween = TweenMax.to(this.scale, 0.1, {x:0.9, y:0.9, yoyo:true, repeat:-1, paused:true});
    }

    changeSymbol(id) {
        this.id = id;
        this.goToFrame(id);
        this.image = this.getChildAt(0);
        this.setActive(this.active);
    }

    startAnimation() {
        this.animationTween.play(0);
    }

    stopAnimation() {
        this.animationTween.pause();
        this.scale.set(1, 1);
    }

    setBlur(value) {
        this.goToFrame(value ? this.id + this.config.count : this.id);
        this.setActive(this.active);
    }

    setActive(value) {
        this.active = value;
        let image = this.getChildAt(0);
        if(!image.tint) {
            image = image.getChildAt(0);
        }
        image.tint = this.active ? 16777215 : this.incativeTintColor;
    }
}
